<template>
    <div class="page__inner page__bg page__bg-01 text-center d-flex">
        <div class="content container d-flex align-items-center justify-content-center flex-column flex-grow-1">
            <div class="row mb-5">
                <div class="col-12">
                    <img src="@/assets/global/mark__red.svg" class="img-fluid">
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h1 class="text-uppercase color--black font-weight-bold text-center" v-html="$t('INTRO_HEADLINE')">Brand History</h1>
                    <p class="color--black text-center font-24 mt-4" v-html="$t('INTRO_TEXT')">Shiseido has a rich and vibrant history. More than merely
                        a beauty brand, for over 140 years the company has
                        always provided inspiration by being innovative and
                        creative, producing timeless products and remaining a
                        leader in the field of beauty and skincare. Here, we
                        explore the many milestones that make Shiseido the
                        iconic company it is today.
                    </p>
                    <router-link :to="{ name: 'pages', params: { kapitel:'01', id:'020' }}" class="btn btn-red my-5">
                                 <div class="btn-inner" v-html="$t('INTRO_BUTTON')">discover <span>the history</span></div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import lrsService from "@/services/lrsService";
    import { Hooper, Slide, Pagination as HooperPagination } from 'hooper';

    export default {
        name: "page-010",
        components:{
        },
        props:{
            kapitel: ""
        },
        data: function () {
            return {

            }
        },
        methods: {

        }
    }
</script>

<style scoped>

</style>